import { Spacing16, Spacing32 } from 'autogen/design-tokens/tokens';
import PageAction from 'components/shared/Routing/PageAction';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
    display: block;
`;

export const ImageContainer = styled.div`
    width: 100%;
    height: auto;
    position: relative;

`;

export const EventContentContainer = styled.div`
    background: #ffffff;
`;

export const EventContent = styled.div`
    padding: 20px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;         
`;

export const EventTitle = styled.span`
    font-size: 1.7142857143em;
    color: #002643;
    max-width: 100%;
    font-family: 'DM_Serif_Text', serif;
`;

export const EventDescription = styled.span`
    font-size: 1.1428571429em;
    margin: 10px 0;
    max-width: 100%;
`;

export const EventDate = styled.span`
    font-size: 1.0714285714em;
    padding: 15px 0;
    border: 1px solid #002643;
    border-right: 0;
    border-left: 0;
    margin: 10px 0;
    color: #002643;
    font-weight: bold;
    width: 315px;
    max-width: 100%;
`;

export const EventLiveLink = styled(PageAction)`
    font-size: 1.1428571429em;
    font-family: 'Inter', sans-serif;
    font-weight: bold;
    color: #002643;
    margin-top: 5px;
    padding: 0.36em;
    text-decoration: none;
`;
